import { render, staticRenderFns } from "./CompSeals.vue?vue&type=template&id=8c67b83e"
import script from "./CompSeals.vue?vue&type=script&lang=js"
export * from "./CompSeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports